import React from 'react';

const IWantToFilterItems = ({
	bgColor,
	themefilterclass,
	displayText,
	setElementFilter,
	theme,
	elementFilter,
}) => (
	<li>
		<span
			id={`${theme}`}
			className={`${bgColor} btn1 ${themefilterclass} `}
			onClick={() => setElementFilter(theme)}
		>
			{displayText}
		</span>
	</li>
);

export default IWantToFilterItems;
